import { Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import { useEffect } from "react"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import Panorama from "./Panorama"
import UpholsterySidebar from "./UpholsterySidebar"
import { selectedUpholsterySelector } from "./upholsterySelectors"
import { setSelectedUpholstery } from "./upholsterySlice"

// const StyledProgressContainer = styled.div`
//   width: 100%;
//   height: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `

// const Panorama = dynamic(() => import("./Panorama"), {
//   // eslint-disable-next-line react/display-name
//   loading: () => (
//     <StyledProgressContainer>
//       <CircularProgress size="50px" />
//     </StyledProgressContainer>
//   ),
// })

const StyledPageWrap = styled.div`
  position: absolute;
  inset: 0;
  margin: 0;
  ${(p) => p.theme.breakpoints.down("sm")} {
    // inset-block-start: 77px;
    inset: 48px 0 315px 0;
  }
`
const StyledUpholsterySidebarWrap = styled.div`
  position: absolute;
  left: 0;
  top: calc(100% - 45px);
  z-index: 1;
  width: 100%;
  pointer-events: none;
`
const StyledPanoramaIcon = styled.img`
  position: absolute;
  z-index: 1;

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 50px;
    top: 20px;
    right: 5px;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 67px;
    bottom: 130px;
    right: 27px;
  }
`

const UpholsteryPage = () => {
  const selectedUpholstery = useTypedSelector(selectedUpholsterySelector)
  const { upholsteries } = useTypedSelector((state) => state.upholstery)
  const isDesktop = useIsDesktop()
  const dispatch = useAppDispatch()

  // On mount, if there's no selected upholstery, select the first one
  useEffect(() => {
    if (selectedUpholstery || upholsteries.length === 0) return

    dispatch(setSelectedUpholstery(upholsteries[0].details.code))
  }, [selectedUpholstery, dispatch, upholsteries])

  if (!selectedUpholstery) return null

  return (
    <StyledPageWrap>
      <Typography variant="srOnly" id="panoramaLabel">
        רכיב פנורמה, ניתן לנווט עם חצי המקלדת
      </Typography>
      {/* <SphereViewer image={selectedUpholstery.details.images[0]?.imageUrl} /> */}
      <Panorama image={selectedUpholstery.details.images[0]?.imageUrl} />
      {!isDesktop ? (
        <>
          <StyledUpholsterySidebarWrap>
            <UpholsterySidebar />
          </StyledUpholsterySidebarWrap>

          <StyledPanoramaIcon
            src="/360-mobile.svg"
            alt=""
            title="רכיב 360, ניתן לסובב על ידי לחיצה ממושכת על המסך"
          />
        </>
      ) : (
        <StyledPanoramaIcon
          src="/360-desktop.svg"
          alt=""
          title="רכיב 360, ניתן לסובב על ידי לחיצה ממושכת על המסך"
        />
      )}
    </StyledPageWrap>
  )
}

export default UpholsteryPage
